export default __webpack_public_path__ + "static/media/knowledge-image.a28c6861.png";